import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { CustomSwitch } from "components/Input/Index.js";
import moment from "moment";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberorder } from "variables/markets";
import { putMarketMembershipOrder, generateMarketMembershipOrderFile, downloadFile } from "services/ConfigServices";
import ReactLoading from "react-loading";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const LoadingDiv = styled.div`
  height: 32px;
  width: 97%;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  padding-top: 5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-top: 10px;
`;

function SendServiceOrderDialog(props) {
  const { closeModal, refetch, serviceorder, market } = props;
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [sendtoprovider, setSendtoprovider] = useState(false);
  const [file, setFile] = useState(serviceorder.parameters.generatedfile);

  const handleSubmit = async (event) => {
    updateMarketMembershipOrder(event);
  };

  const updateMarketMembershipOrder = async (event) => {
    await axios
      .put(
        putMarketMembershipOrder(serviceorder.id, market.id, sendtoprovider ? "adminvalidationandsend" : "adminvalidation"),
        {
          serviceorderparameters:
          {
            ...serviceorder.parameters,
            status: 'validated',
            validationdate: (moment().unix()) * 1000,
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Ordre de service validé");
        } else setNotification("error", "Une erreur est survenue ici");
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error);
        setNotification("error", "Une erreur est survenue là");
      });
  };

  const handleSendtoprovider = async (event) => {
    setSendtoprovider(!sendtoprovider);
  };


  const downloadGED = (fileId, fileName) => async () => {
    axios
      .get(
        downloadFile(fileId),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };


  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            {!file &&
              <DataContainer>
                <Data>{memberorder.fileunavailable}</Data>
              </DataContainer>
            }
            {
              file &&
              <>
                <DataContainer>
                  <Data>{memberorder.filegenerated}</Data>
                  <DataResultLink onClick={downloadGED(file.fileId, file.fileName)}>
                    {file.fileName}
                  </DataResultLink>
                </DataContainer>
                {
                  market?.parameters?.provider?.contacts?.length > 0 ?

                    <div>
                      <CustomSwitch
                        inputTitle={memberorder.sendtoprovider}
                        checkedState={sendtoprovider}
                        handleSwitchChange={handleSendtoprovider}
                      />
                    </div>
                    :
                    <DataContainer>
                      <Data>{memberorder.nocontacts}</Data>
                    </DataContainer>
                }
                <Button
                  disabled={buttonDisabled}
                  className={
                    buttonDisabled
                      ? classes.submitButtonDisabled
                      : classes.submitButton
                  }
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {memberorder.validateserviceorder}
                </Button>
              </>
            }
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default SendServiceOrderDialog;
